<template>
  <div>
    <!-- 发票预览弹框 -->
    <el-dialog v-model="open" :title="title"
               @open="onOpen"
               modal-class="invoice-dialog-wrapper-9312"
               width="1180">
      <div class="fapiao-preview" :class="[`preview-type-${props.row.invoiceBusiness}`]">
        <header class="fapiao-header">
          <div class="header-l">
            <img class="header-l-qrcode"
                 src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-03-20/1742442493109_2211112.png"/>

            <div class="header-l-tag" v-if="row.invoiceBusiness">
              {{ getLabel(optionsInvoiceBusiness, row.invoiceBusiness) }}
            </div>
          </div>
          <div class="header-c">
            <p>电子发票（{{ row.categoryCode == 2 ? "增值税专用" : "普通" }}发票）</p>
          </div>
          <div class="header-r">
            <p><span>发票号码</span>：{{ row.number || "-" }}</p>
            <p><span>开票日期</span>：{{ dateFormat(row.makeDate) }}</p>
          </div>
        </header>

        <div class="fapiao-body">
          <div class="fapiao-body-header">
            <dl>
              <dt>购买方信息</dt>
              <dd>
                <div><span>名称：</span>{{ row.buyer?.name }}</div>
                <div><span>统一社会信用代码/纳税人识别号：</span>{{ row.buyer?.taxRegistrationNo }}</div>
              </dd>
            </dl>
            <dl>
              <dt>销售方信息</dt>
              <dd>
                <div><span>名称：</span>{{ row.seller?.name }}</div>
                <div><span>统一社会信用代码/纳税人识别号：</span>{{ row.seller?.taxRegistrationNo }}</div>
              </dd>
            </dl>
          </div>

          <div class="fapiao-body-table">
            <div class="table-content">
              <!-- 普通 货物运输服务 -->
              <table v-if="isCommon || isBusinessShipping">
                <colgroup>
                  <template v-if="isCommon">
                    <col style="width: 215px"/>
                    <col style="width: 120px"/>
                  </template>
                  <template v-if="isBusinessShipping">
                    <col style="width: 335px"/>
                  </template>

                  <col style="width: 80px"/>
                  <col style="width: 129px"/>
                  <col style="width: 129px"/>
                  <col style="width: 145px"/>
                  <col style="width: 95px"/>
                  <col style="width: 145px"/>
                </colgroup>
                <thead>
                <tr>
                  <th class="t-align-center">项目名称</th>
                  <th class="t-align-left" v-if="isCommon">规格型号</th>
                  <th class="t-align-center">单 位</th>
                  <th class="t-align-right">数 量</th>
                  <th class="t-align-right">单 价</th>
                  <th class="t-align-right">金 额</th>
                  <th class="t-align-center">税率/征收率</th>
                  <th class="t-align-right">税 额</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of row.items" :key="index">
                  <td class="t-align-left">{{ item.name }}</td>
                  <td class="t-align-left" v-if="isCommon">{{ item.specification }}</td>
                  <td class="t-align-center">{{ item.unit }}</td>
                  <td class="t-align-right">{{ item.count }}</td>
                  <td class="t-align-right">{{ item.show_price }}</td>
                  <td class="t-align-right">{{ item.show_amount }}</td>
                  <td class="t-align-center">{{ item.rate * 100 }}%</td>
                  <td class="t-align-right">{{ item.taxAmount }}</td>
                </tr>
                </tbody>
              </table>

              <!-- 建筑服务 -->
              <table v-if="isBusinessBuilding">
                <colgroup>
                  <col style="width: 215px"/>
                  <col style="width: 233px"/>
                  <col style="width: 233px"/>
                  <col style="width: 145px"/>
                  <col style="width: 85px"/>
                  <col style="width: 145px"/>
                </colgroup>
                <thead>
                <tr>
                  <th class="t-align-center">项目名称</th>
                  <th class="t-align-left">建筑服务发生地</th>
                  <th class="t-align-left">建筑项目名称</th>
                  <th class="t-align-right">金 额</th>
                  <th class="t-align-center">税率/征收率</th>
                  <th class="t-align-right">税 额</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of row.items" :key="index">
                  <td class="t-align-left">{{ item.name }}</td>
                  <td class="t-align-left">{{ addressFormat(row.itemsBusinessBuilding.locationName) }}</td>
                  <td class="t-align-left">{{ row.itemsBusinessBuilding.projectName }}</td>
                  <td class="t-align-right">{{ item.show_amount }}</td>
                  <td class="t-align-center">{{ item.rate * 100 }}%</td>
                  <td class="t-align-right">{{ item.taxAmount }}</td>
                </tr>
                </tbody>
              </table>

              <!-- 不动产经营租赁服务 -->
              <table v-if="isBusinessLeasing">
                <colgroup>
                  <col style="width: 133px"/>
                  <col style="width: 200px"/>
                  <col style="width: 80px"/>
                  <col style="width: 129px"/>
                  <col style="width: 129px"/>
                  <col style="width: 145px"/>
                  <col style="width: 95px"/>
                  <col style="width: 145px"/>
                </colgroup>
                <thead>
                <tr>
                  <th class="t-align-center">项目名称</th>
                  <th class="t-align-left">产权证书/不动产权证号</th>
                  <th class="t-align-center">面积单位</th>
                  <th class="t-align-right">数 量</th>
                  <th class="t-align-right">单 价</th>
                  <th class="t-align-right">金 额</th>
                  <th class="t-align-center">税率/征收率</th>
                  <th class="t-align-right">税 额</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of row.items" :key="index">
                  <td class="t-align-left">{{ item.name }}</td>
                  <td class="t-align-left">{{ row.itemsBusinessLeasing.no }}</td>
                  <td class="t-align-center">{{ getLabel(unitOptions, row.itemsBusinessLeasing.unit) }}</td>
                  <td class="t-align-right">{{ item.count }}</td>
                  <td class="t-align-right">{{ item.show_price }}</td>
                  <td class="t-align-right">{{ item.show_amount }}</td>
                  <td class="t-align-center">{{ item.rate * 100 }}%</td>
                  <td class="t-align-right">{{ item.taxAmount }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="table-footer">
              <span class="invoice-color">合计</span>
              <span>¥{{ row.show_totalAmount }}</span>
              <span>¥{{ row.totalTaxAmount }}</span>
            </div>
          </div>

          <!-- 货物运输服务 -->
          <div class="fapiao-body-table fapiao-body-table-2" v-if="isBusinessShipping">
            <div class="table-content">
              <table>
                <colgroup>
                  <col style="width: 240px"/>
                  <col style="width: 160px"/>
                  <col style="width: 160px"/>
                  <col style="width: 160px"/>
                  <col style="width: 334px"/>
                </colgroup>
                <thead>
                <tr>
                  <th class="t-align-center">运输工具种类</th>
                  <th class="t-align-center">运输工具牌号</th>
                  <th class="t-align-center">起运地</th>
                  <th class="t-align-center">到达地</th>
                  <th class="t-align-center">运输货物名称</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of row.itemsBusinessShipping" :key="index">
                  <td class="t-align-center">{{ getLabel(businessShippingOptions, item.type) }}</td>
                  <td class="t-align-center">{{ item.no }}</td>
                  <td class="t-align-center">{{ addressFormat(item.dispatchName) }}</td>
                  <td class="t-align-center">{{ addressFormat(item.arriveName) }}</td>
                  <td class="t-align-center">{{ item.name }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="fapiao-body-total">
            <p class="invoice-color">价税合计（大写）</p>

            <dl>
              <dt><span>⊗</span>{{ row.payee }}</dt>
              <dd
                  style="margin-left: 220px;"
              ><span class="invoice-color">（小写）</span>¥{{ row.totalAddedTaxAmount }}
              </dd>
            </dl>
          </div>

          <div class="fapiao-body-remark">
            <span class="invoice-color">备注</span>

            <div>
              <!-- 建筑服务 -->
              <el-row v-if="isBusinessBuilding" :gutter="10">
                <el-col :span="8">
                  <p><span class="invoice-color">土地增值税项目编号：</span>{{ row.itemsBusinessBuilding.no }}</p>
                </el-col>
                <el-col :span="8"><span class="invoice-color">跨地（市）标志：</span>{{
                    getLabel(businessBuildingOptions, row.itemsBusinessBuilding.tag)
                  }}
                </el-col>
              </el-row>

              <!-- 不动产租赁服务 -->
              <template v-if="isBusinessLeasing">
                <el-row v-for="(item, index) of row.itemsBusinessLeasing" :key="index" :gutter="10">
                  <el-col :span="24" v-if="row.itemsBusinessLeasing.length > 1">
                    <h6 class="h6-leasing">
                      不动产信息<span v-if="index > 0">{{ index + 1 }}</span
                    >：
                    </h6>
                  </el-col>

                  <el-col :span="8">
                    <p><span class="invoice-color">不动产地址：</span>{{ addressFormat(item.areaName) }}</p>
                  </el-col>
                  <el-col :span="8"><span class="invoice-color">租赁期起止：</span>{{ timeFormat(item.startEndTime) }}
                  </el-col>
                  <el-col :span="8"><span
                      class="invoice-color">跨地（市）标志：</span>{{ getLabel(businessBuildingOptions, item.tag) }}
                  </el-col>
                </el-row>
              </template>

              <p>{{ row.remark }}</p>
            </div>
          </div>
        </div>

        <div class="fapiao-footer"><span class="invoice-color">开票人：</span>{{ row.maker || "-" }}</div>
      </div>

      <template #footer>
        <el-button type="default" size="small" @click="open = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import Big from "big.js";

const props = defineProps({
  row: {
    type: Object,
    default: () => ({}),
  },
});

const title = computed(() => {
  return props.row.id ? "发票详情" : "发票预览";
});

const open = defineModel({type: Boolean, default: false});

function onOpen() {
  (props.row.items || []).forEach(e => {
    if (props.row.addedTax) { // 含税价
      e.show_price = parseFloat(new Big(e.price).div(new Big(1).plus(e.rate)).round(3).toString())
      e.show_amount = parseFloat(new Big(e.amount).div(new Big(1).plus(e.rate)).round(2).toString())
    } else {
      e.show_price = e.price
      e.show_amount = e.amount
    }
  })

  props.row.show_totalAmount = props.row.addedTax ? ((props.row.items || []).reduce((prev, item) => {
    prev = prev.plus(item.show_amount)
    return prev
  }, new Big(0)).toString()) : props.row.totalAmount
  console.log('预览发票数据', props.row)
}

// 是否常规
const isCommon = computed(() => {
  return !props.row.invoiceBusiness;
});
// 是否建筑
const isBusinessBuilding = computed(() => {
  return props.row.invoiceBusiness == 1;
});
// 是否货物运输
const isBusinessShipping = computed(() => {
  return props.row.invoiceBusiness == 2;
});
// 是否不动产经营租赁服务
const isBusinessLeasing = computed(() => {
  return props.row.invoiceBusiness == 3;
});

const optionsInvoiceBusiness = [
  {label: "建筑服务", value: "1"},
  {label: "货物运输服务", value: "2"},
  {label: "不动产经营租赁服务", value: "3"},
];

const businessShippingOptions = [
  {label: "铁路运输", value: "1"},
  {label: "公路运输", value: "2"},
  {label: "水路运输", value: "3"},
  {label: "航空运输", value: "4"},
  {label: "管道运输", value: "5"},
  {label: "其他运输工具", value: "6"},
];

const businessBuildingOptions = [
  {label: "是", value: "1"},
  {label: "否", value: "0"},
];

const unitOptions = [
  {label: "米（铁路线与管道等使用）", value: "1"},
  {label: "平方千米", value: "2"},
  {label: "平方米", value: "3"},
  {label: "公顷", value: "4"},
  {label: "亩", value: "5"},
  {label: "h㎡", value: "6"},
  {label: "k㎡", value: "7"},
  {label: "㎡", value: "8"},
];

function getLabel(options, value) {
  const findItem = options.find((item) => item.value == value);

  return (findItem && findItem.label) || "";
}

function addressFormat(str) {
  return (str || "").replace(/\s|\//g, "");
}

function timeFormat(arr) {
  return arr.join(" ");
}

function dateFormat(date) {
  try {
    return dayjs(date).format("YYYY年MM月DD日");
  } catch (e) {
    return date;
  }
}
</script>

<style lang="scss" scoped>
.fapiao-preview {
  width: 1080px;
  margin: 0 auto;
  font-family: SimSun, STSong;
  color: #333333;

  $primaryColor: #c08834;

  &.preview-type-2 {
    .table-content {
      height: 100px !important;
    }
  }

  .invoice-color {
    color: $primaryColor;
  }

  .fapiao-header {
    height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    margin-bottom: 16px;
    padding-right: 20px;

    .header-l {
      height: 88px;
      display: flex;

      .header-l-qrcode {
        width: 88px;
        height: 88px;
        margin-right: 8px;
      }

      .header-l-tag {
        width: 166px;
        height: 88px;
        font-weight: 600;
        border: 2px dashed $primaryColor;
        font-size: 14px;
        color: $primaryColor;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .header-c {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      font-size: 28px;
      color: $primaryColor;
      white-space: nowrap;
      border-bottom: 2px solid $primaryColor;
      padding-bottom: 4px;

      p {
        font-weight: 700;
        line-height: 2;
        border-bottom: 2px solid $primaryColor;
      }
    }

    .header-r {
      p {
        margin-bottom: 15px;

        span {
          color: $primaryColor;
        }
      }
    }
  }

  .fapiao-body {
    border: 2px solid $primaryColor;

    .fapiao-body-header {
      display: flex;
      height: 90px;

      > dl {
        flex: 1;
        display: flex;

        &:not(:nth-of-type(1)) {
          dt {
            border-left: 2px solid $primaryColor;
          }
        }

        dt {
          width: 34px;
          box-sizing: border-box;
          color: $primaryColor;
          padding: 0 8px;
          display: flex;
          align-items: center;
          flex: 0 0 auto;
          overflow: hidden;
          border-right: 2px solid $primaryColor;
        }

        dd {
          width: 100%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          padding: 0 12px;

          > div {
            width: 100%;
            word-break: break-all;

            &:nth-of-type(1) {
              min-height: 38px;
            }

            span {
              color: $primaryColor;
            }
          }
        }
      }
    }

    .fapiao-body-table {
      border-top: 2px solid $primaryColor;

      .table-content {
        height: 220px;
        line-height: 1.6;
        overflow-y: auto;

        table {
          width: 100%;
          font-family: SimSun, STSong;

          thead {
            position: sticky;
            z-index: 100;

            th {
              padding: 0 4px;
              color: $primaryColor;
              text-align: center;
              white-space: nowrap;
              border: 0;
              vertical-align: middle;
            }
          }

          tbody {
            td {
              padding: 1px 2px;
              font-family: SimSun, STSong;
              color: #666;
              border: 0;
              vertical-align: middle;
            }

            tr {
              border-bottom: 1px solid #e7e4e4;
            }
          }

          .t-align-left {
            text-align: left;
          }

          .t-align-center {
            text-align: center;
          }

          .t-align-right {
            text-align: right;
          }
        }
      }

      .table-footer {
        position: relative;
        height: 40px;
        line-height: 40px;

        span {
          position: absolute;
          top: 0;
          white-space: nowrap;

          &:nth-of-type(1) {
            left: 76px;
          }

          &:nth-of-type(2) {
            right: 250px;
          }

          &:nth-of-type(3) {
            right: 20px;
          }
        }
      }
    }

    .fapiao-body-total {
      height: 36px;
      border-top: 2px solid $primaryColor;
      display: flex;

      > p {
        width: 240px;
        flex: 0 0 auto;
        overflow: hidden;
        border-right: 2px solid $primaryColor;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      > dl {
        width: 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 100px 0 16px;

        > dt {
          font-size: 12px;

          span {
            margin-right: 3px;
          }
        }
      }
    }

    .fapiao-body-remark {
      height: 100px;
      border-top: 2px solid $primaryColor;
      display: flex;

      .h6-leasing {
        margin-bottom: 10px;
      }

      > span {
        width: 34px;
        flex: 0 0 auto;
        overflow: hidden;
        border-right: 2px solid $primaryColor;
        display: flex;
        justify-content: center;
        //align-items: center
        line-height: 30px;
        padding: 3px 8px 0 8px;
        box-sizing: border-box;
      }

      > div {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        padding: 16px;
        word-break: break-word;
        overflow-y: auto;

        > * {
          margin-bottom: 20px;
        }
      }
    }
  }

  .fapiao-footer {
    padding: 16px 40px;
  }
}
</style>

<style lang="scss">
.invoice-dialog-wrapper-9312 {
  .el-dialog__footer {
    padding-top: 0;
  }
}
</style>
